var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9897 4.11375C12.9907 0.706093 7.98962 -0.210556 4.23204 2.90983C0.474466 6.03022 -0.0545484 11.2474 2.8963 14.9379C5.34973 18.0063 12.7747 24.4777 15.2082 26.5723C15.4804 26.8067 15.6165 26.9238 15.7753 26.9699C15.9139 27.01 16.0655 27.01 16.2041 26.9699C16.3629 26.9238 16.499 26.8067 16.7713 26.5723C19.2048 24.4777 26.6297 18.0063 29.0832 14.9379C32.034 11.2474 31.5696 5.9974 27.7474 2.90983C23.9252 -0.177733 18.9888 0.706093 15.9897 4.11375Z",
    stroke: "#282828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4a8d54b22199e25b61469042d4c6bc32.svg";
export { ForwardRef as ReactComponent };